import { cn } from '@antimatterhq/ui/lib/utils';

export type SpacerProps = {
  size: Size;
};

export default function Spacer({ size }: SpacerProps) {
  return (
    <div
      className={cn(
        'h-2',
        size === 'sm' && 'h-1',
        size === 'lg' && 'h-4',
        size === 'xl' && 'h-6',
        size === '2xl' && 'h-8',
      )}
    />
  );
}
